var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(!_vm.is_culture&&!_vm.$route.meta.hideFoot)?_c('btm'):_vm._e(),(_vm.show_im && !_vm.$route.meta.hideIM)?_c('imalert',{attrs:{"im_gid":_vm.im_gid,"im_popupid":_vm.im_popupid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }